import type React from "react";
import { createContext, useContext } from "react";
import type { MenuType, TypeComponent } from "./shared";

/** Interface */
interface IMenuContext {
	type: MenuType;
	TypeComponent: TypeComponent;
	side?: "top" | "bottom" | "left" | "right";
	align?: "start" | "center" | "end";
	SubMenu?: React.ComponentType<{ items: any; type: "sub"; maxHeight?: number }>;
}

/** Context */
export const MenuContext = createContext<IMenuContext>({} as IMenuContext);

/** Hooks */
export function useMenuContext() {
	return useContext(MenuContext);
}
